import check_checkbox from './contact-form-gdpr.js';
import {
  max_height_double_image_block,
  image_text_fill_height,
  animate_achievement,
  animate_number_when_scrolling,
  imagebank_block_functionality,
  embed_video,
  block_column_images,
  block_column_fullwidth,
  image_gallery
 } from './wp_block_scripts.js';
 import { important_notice } from './header';
 import { footer_popop } from './footer';

import mobile_menu from './mobile-menu.js';

export default function heimdall_wp() {
  //submenu_btn();
  scale_hero_text();
  init();
  check_checkbox();
  max_height_double_image_block();
  image_text_fill_height();
  imagebank_block_functionality();
  embed_video();
  image_gallery();
  animate_number_when_scrolling();
  important_notice();
  footer_popop();

  $(window).load(()=> {
    block_column_images();
    block_column_fullwidth();
  })

  // burger_menu();


  function init() {
    $(window).scroll(function (event) {
      if ($('.navigation').length > 0) {
        var scroll = $(window).scrollTop();
        var navigation_offset = $('.navigation').offset().top + $('.navigation').outerHeight();
        if (scroll > navigation_offset) {
          $('.sticky-navigation-wrap').addClass('show');
        } else {
          $('.sticky-navigation-wrap').removeClass('show');
        }
      }
    });

    $(window).scroll(animate_number_when_scrolling);

    $(window).on('resize', function() {
      // embed();
      max_height_double_image_block();
      if (window.innerWidth > 960) {
        $('.navigation').removeClass('open');
      }
    });

/// function for mobile hide header when scroll down / show when scroll up
    (function(){
      let doc = document.documentElement;
      let w = window;
      let prevScroll = w.scrollY || doc.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;
      let header = document.getElementById('site-header');
      let checkScroll = function() {
        if (window.outerWidth < 1024) {
          curScroll = w.scrollY || doc.scrollTop;
          if (curScroll > prevScroll) {
            direction = 2;
          }
          else if (curScroll < prevScroll) {
            direction = 1;
          }
          if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
          }
          prevScroll = curScroll;
        }
      };
      let toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > 90) {
          header.classList.add('hide');
          prevDirection = direction;
        }
        else if (direction === 1) {
          header.classList.remove('hide');
          prevDirection = direction;
        }
      };
      window.addEventListener('scroll', checkScroll);
    })();
  }

  function submenu_btn() {
    $('.menu-item-has-children').each(function() {
        $('> a', this).append('<div class="submenu-btn">&nbsp;</div>');
    });
    $('.submenu-btn').click(function(e) {
      e.preventDefault();
      $(this).closest('.menu-item-has-children').toggleClass('open-submenu');
    });
  }

// function for toggle burger menu
  (function() {
    $("#burger-menu-open").click(function() {
      $('.mobile-menu').toggleClass('show');
    });
      $("#burger-menu-close").click(function(){
        $('.mobile-menu').toggleClass('show');
      });
  })();


  //Anpassa textstorlek i heroblocket för att inte bryta ord
  function scale_hero_text() {
    if ((window.outerWidth) < 768 && $('.hero-text').length > 0 && $('.hero-text').width() < $('.hero-text > span').width()) {
      while ($('.hero-text').width() < $('.hero-text > span').width()) {
        var fontsize = parseFloat($('.hero-text > span').css('font-size'));
        fontsize = --fontsize;
        $('.hero-text > span').css('font-size', fontsize + 'px');
      }
    }
  }
}
